import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * ERV Icon Style04 - Rotating Fan icon
 * 風扇圖示 - 旋轉扇葉
 */
export const Style04_Fan: React.FC<DeviceIconProps> = ({ 
  isOn = false, 
  size = 'small',
  className = '',
  animated = false 
}) => {
  const sizeInPx = getSizeInPixels(size);
  const primaryColor = isOn ? '#2dd4bf' : '#64748b'; // teal-400 : slate-500
  
  return (
    <svg
      viewBox="0 0 24 24"
      width={sizeInPx}
      height={sizeInPx}
      fill="none"
      className={`${className} ${animated && isOn ? 'animate-spin' : ''}`}
      style={animated && isOn ? { animationDuration: '2s' } : undefined}
    >
      {/* Center hub */}
      <circle
        cx="12"
        cy="12"
        r="2"
        fill={primaryColor}
      />
      
      {/* Fan blades */}
      <path
        d="M12 10C12 10 12 4 8 4C4 4 4 8 6 10C8 12 12 10 12 10Z"
        fill={primaryColor}
        opacity="0.8"
      />
      <path
        d="M14 12C14 12 20 12 20 8C20 4 16 4 14 6C12 8 14 12 14 12Z"
        fill={primaryColor}
        opacity="0.8"
      />
      <path
        d="M12 14C12 14 12 20 16 20C20 20 20 16 18 14C16 12 12 14 12 14Z"
        fill={primaryColor}
        opacity="0.8"
      />
      <path
        d="M10 12C10 12 4 12 4 16C4 20 8 20 10 18C12 16 10 12 10 12Z"
        fill={primaryColor}
        opacity="0.8"
      />
    </svg>
  );
};

export default Style04_Fan;
